import React, {Component} from 'react'
import {Grid} from 'semantic-ui-react'

export default class DumbComponent extends Component {
    render() {
        return(
            <Grid>
            </Grid>
        )
    }
}